export const EditNavbar = {
  NavbarButtonSet_title: {
    padding: '0',
    Text: {
      ignoreChildExtends: true,
      text: '{{ key }}'
    },
    CopyButton: {
      title: (el) => el.call('polyglot', 'editor.editNavbar.copyTitle'),
      value: (el, s) => s.key
    }
  },
  EditorTools: {
    hide: true,
    margin: '- auto - C3',
    // eslint-disable-next-line no-restricted-syntax -- icon toolbar default color, not text
    color: 'inactive',
    fontSize: 'Z1'
  },
  EditorPositionNavbar: {
    margin: '- - - auto'
  },
  NavbarButtonSet_meta: {
    Que: {
      title: (el) => el.call('polyglot', 'editor.command.docs.description'),
      icon: 'questionMark',
      isActive: false,
      onClick: (ev, el) => {
        el.setWindow('docs', '/properties')
      }
    },
    Close: {
      title: (el) => el.call('polyglot', 'common.action.close'),
      icon: 'crossmark',
      isActive: false,
      margin: '- - - X',
      onClick: (ev, el) => {
        el.closeWindow('componentEditor')
      }
    }
  },
  extends: 'Navbar',
  position: 'sticky',
  top: '0',
  width: '100%',
  padding: 'W X W Z2',
  fontSize: '1rem'
}
